/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Apikeys_Delete_FailedInputs */

const en_settings_apikeys_delete_failed = /** @type {(inputs: Settings_Apikeys_Delete_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to delete API key`)
};

const zh_settings_apikeys_delete_failed = /** @type {(inputs: Settings_Apikeys_Delete_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API 密钥删除失败`)
};

/**
* | output |
* | --- |
* | "Failed to delete API key" |
*
* @param {Settings_Apikeys_Delete_FailedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_apikeys_delete_failed = /** @type {((inputs?: Settings_Apikeys_Delete_FailedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Apikeys_Delete_FailedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_apikeys_delete_failed(inputs)
	return zh_settings_apikeys_delete_failed(inputs)
});
export { settings_apikeys_delete_failed as "settings.apikeys.delete_failed" }